//防抖事件
let timeout = null
function debounce(fn, wait) {
 if(timeout !== null) clearTimeout(timeout)
 timeout = setTimeout(fn, wait)
}
export default debounce


// WEBPACK FOOTER //
// ./src/utils/debounce.js